import { render, staticRenderFns } from "./BtNotifications.vue?vue&type=template&id=6094b258&scoped=true&"
import script from "./BtNotifications.vue?vue&type=script&lang=js&"
export * from "./BtNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BtNotifications.vue?vue&type=style&index=0&id=6094b258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094b258",
  null
  
)

export default component.exports